import { v4 as uuidv4 } from "uuid"

import { addItemEntityBase } from "./firebaseBaseDataUtils.js"
import { getFechaObj } from "./commonUtils.js"
import { getUserInfo } from "./usuarios-commons.js"

export const pagos_entity = "pagos"
export const pagos_area = "user-priv-data-read"

export const crearPagoBase = async (
  firebase,
  siteId,
  data,
  user,
  suscripcion,
) => {
  console.debug("🚀 ~ pagos-commons.js:9 ~ crearPagoBase ~ data:", data)

  const { id = uuidv4(), fechaPagoDate = new Date(), ...rest } = data

  const fechaPagoObj = getFechaObj("fechaPago", fechaPagoDate, undefined, {timezone: "America/Mexico_City"})

  const newData = {
    ...rest,
    ...fechaPagoObj,
    id,
  }

  if(user?.email){
    newData["user-email"] = user.email
    newData["user-uid"] = user.uid || null
    newData["user-info"] = getUserInfo(user)
  }
  if (suscripcion) {
    newData.suscripcion = suscripcion || null
    newData.sus_key = suscripcion.key || null
    newData.sus_id = suscripcion["suscripcion-key"] || null
    newData.sus_ACTIVO = suscripcion.ACTIVO || null
    newData.sus_codigo = suscripcion.codigo || null
  }

  const newPago = await addItemEntityBase(
    firebase,
    siteId,
    pagos_entity,
    pagos_area,
    id,
    newData,
    {
      includeKey: true,
    },
  )

  return newPago
}
